"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactMethodToJSON = exports.ContactMethodFromJSONTyped = exports.ContactMethodFromJSON = exports.ContactMethod = void 0;
/**
 * The ways in which we can contact the enrollee.
 * @export
 * @enum {string}
 */
var ContactMethod;
(function (ContactMethod) {
    ContactMethod["EMAIL"] = "EMAIL";
    ContactMethod["CALL"] = "CALL";
    ContactMethod["TEXT"] = "TEXT";
})(ContactMethod = exports.ContactMethod || (exports.ContactMethod = {}));
function ContactMethodFromJSON(json) {
    return ContactMethodFromJSONTyped(json, false);
}
exports.ContactMethodFromJSON = ContactMethodFromJSON;
function ContactMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ContactMethodFromJSONTyped = ContactMethodFromJSONTyped;
function ContactMethodToJSON(value) {
    return value;
}
exports.ContactMethodToJSON = ContactMethodToJSON;
//# sourceMappingURL=ContactMethod.js.map